import React from 'react';

export default function LabResults({ labResults, addLab, updLab, delLab, moldChange }) {
  return (
    <div className="mb-6">
      <button
        onClick={addLab}
        className="px-3 py-1 bg-gray-200 text-gray-800 rounded mb-4"
      >
        Add Laboratory Result
      </button>

      {labResults.map((lab, i) => (
        <div
          key={i}
          className="border border-gray-300 p-4 mb-4 rounded-lg"
        >
          <div className="flex items-center justify-between mb-3">
            <h4 className="font-semibold">
              Lab Result {i + 1}
            </h4>
            <button
              onClick={() => delLab(i)}
              className="bg-red-200 text-red-800 px-2 py-1 rounded"
            >
              Delete
            </button>
          </div>

          {/* Area / Serial / Method */}
          <div className="flex flex-col md:flex-row md:gap-4 mb-4">
            <input
              className="flex-1 w-full md:w-1/3 border border-gray-300 rounded px-2 py-1"
              placeholder="Area"
              value={lab.roomArea}
              onChange={e => updLab(i, 'roomArea', e.target.value)}
            />
            <input
              className="flex-1 w-full md:w-1/3 border border-gray-300 rounded px-2 py-1"
              placeholder="##########"
              value={lab.sampleSerial}
              onChange={e => updLab(i, 'sampleSerial', e.target.value)}
            />
            <select
              className="flex-1 w-full md:w-1/3 border border-gray-300 rounded px-2 py-1"
              value={lab.sampleMethod}
              onChange={e => updLab(i, 'sampleMethod', e.target.value)}
            >
              <option value="">Method</option>
              <option>Air Spore Trap</option>
              <option>Bulk Material Sample</option>
              <option>Swab</option>
              <option>Tape Lift</option>
              <option>qPCR</option>
            </select>
          </div>

          {/* Air Spore Trap specifics */}
          {lab.sampleMethod === 'Air Spore Trap' && (
            <div className="space-y-4 mb-4">
              <select
                className="w-full border border-gray-300 rounded px-2 py-1"
                value={lab.airSampleType}
                onChange={e => updLab(i, 'airSampleType', e.target.value)}
              >
                <option value="">Air Sample Type</option>
                <option>Ambient General Air</option>
                <option>Disturbed General Air</option>
                <option>Mechanical Agitated Wall Cavity</option>
                <option>Mechanically Agitated Structural Cavity</option>
                <option>Direct Surface</option>
              </select>

              <div className="flex flex-col md:flex-row md:gap-4">
                <div className="flex-1">
                  <label className="block mb-1 text-sm">Minutes</label>
                  <input
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    type="number"
                    min="0"
                    value={lab.minutes || ''}
                    onChange={e => updLab(i, 'minutes', e.target.value)}
                  />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 text-sm">Liters</label>
                  <input
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    readOnly
                    value={lab.minutes ? lab.minutes * 15 : ''}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Extent */}
          <div className="mb-4">
            <select
              className="w-full border border-gray-300 rounded px-2 py-1"
              value={lab.extensiveSubstantial}
              onChange={e => updLab(i, 'extensiveSubstantial', e.target.value)}
            >
              <option value="">Extent</option>
              <option>Extensive</option>
              <option>Substantial</option>
              <option>Moderate</option>
              <option>Light</option>
              <option>Trace</option>
              <option>No Significant</option>
            </select>
          </div>

          {/* Mold Genus */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Mold Genus:</label>
            <select
              multiple
              className="w-full h-24 border border-gray-300 rounded px-2 py-1"
              value={lab.moldName}
              onChange={e => moldChange(i, e.target.selectedOptions)}
            >
              {[
                'Aspergillus','Penicillium','Cladosporium','Alternaria',
                'Stachybotrys','Chaetomium','Acremonium','Ulocladium',
                'Trichoderma','Fusarium'
              ].map(g => <option key={g} value={g}>{g}</option>)}
            </select>
          </div>

          <button
            onClick={addLab}
            className="px-3 py-1 bg-gray-200 text-gray-800 rounded"
          >
            Add Laboratory Result
          </button>
        </div>
      ))}
    </div>
  );
}